document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const dropdownLinks = document.querySelectorAll(".yv-dropdown-item-link");
    dropdownLinks.forEach(link => {
      // Only force color specifically here
      link.style.setProperty("color", "#181818", "important");

      // Optional: force via inline style attribute too, as backup
      link.setAttribute("style", (link.getAttribute("style") || "") + "color: #181818 !important;");

      // Add hover listener again
      link.addEventListener("mouseenter", () => {
        link.style.setProperty("color", "#9d6348", "important");
      });
      link.addEventListener("mouseleave", () => {
        link.style.setProperty("color", "#181818", "important");
      });
    });
  }, 150); // Slight delay ensures DOM is fully rendered
});
